import clsx from 'clsx';
import { ReactNode, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useMemo } from 'react';

type Props = {
    children: ReactNode;
    className?: string;
};

const Portal: React.FC<Props> = ({ className, children }) => {
    const div = useMemo(() => {
        const element = document.createElement('div');

        element.className = clsx('custom-portal', className);

        return element;
    }, [className]);

    useEffect(() => {
        const mount = document.body;

        mount?.appendChild(div);

        return () => {
            mount?.removeChild(div);
        };
    }, [div]);

    return createPortal(children, div);
};

export default Portal;
